module.exports = __webpack_public_path__ + "img/essentials.54e3fc1.jpg";